import { ErrorDecoder } from 'ethers-decode-error';

import { ABI_ERRORS } from './error-abi';

const errorDecoder = ErrorDecoder.create([ABI_ERRORS]);

export function decodeError(error: any) {
  return errorDecoder.decode(error);
}
